import type { KeyboardLayout } from 'components/Keyboard/types';

import layoutCandidates from './defaultCandidates';

export default {
  layout: {
    default: [
      '{brackets} {divider} わ ら や ま は {divider} な た さ か あ',
      '？ {divider} を り {//} み ひ {divider} に ち し き い',
      '！ {divider} ん る ゆ む ふ {divider} ぬ つ す く う',
      '、 {divider} ー れ {//} め へ {divider} ね て せ け え',
      '。 {divider} {small} ろ よ も ほ {divider} の と そ こ お',
    ],
  },
  layoutCandidates,
} satisfies KeyboardLayout;
